import { useContext, useEffect, useState } from "react"
import API from "./API"
import { Link, useNavigate, useParams } from "react-router"
import { useForm } from "react-hook-form"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ModalContext } from './ModalContext';
import ApiResult from './ApiResult';
import { AdminQueryCompany, AdminQueryUsage } from "../../backend/src/api/dto"
import DisplayUsage from "./components/DisplayUsage"
import ModalConfirmation from "./Modal/Confirmation"

type FormValues = {
    name: string
    description: string
    status: boolean
}


function Company() {
    const params = useParams();
    let navigate = useNavigate();

    const [data, setData] = useState<{
        company: AdminQueryCompany,
        usage: AdminQueryUsage[]
    }>({
        company: {
            companyId: 0,
            name: '',
            description: '',
            status: false
        },
        usage: [],
    })
    const [apiResult, setApiResult] = useState<null | { status: boolean, message?: string[] }>(null)
    const [showModal, closeModal] = useContext(ModalContext);

    const [loading, setLoading] = useState(true)
    const { register, control, getValues } = useForm<FormValues>({
        defaultValues: async () => {
            if (params.companyId !== "0") {
                const company = await API.getCompany(params.companyId ?? 0)
                setData(prevData => {
                    return {
                        ...prevData,
                        ...company
                    }
                })
                setLoading(false)
                return company.company
            } else {
                setLoading(false)

                return {
                    status: true,
                    name: '',
                    description: ''
                }
            }
        }
    })

    const reloadData = (): Promise<any> => {
        setLoading(true)
        return API.getCompany(params.companyId ?? 0).then(company => {
            setData(prevData => {
                return {
                    ...prevData,
                    ...company,

                }
            })
            setLoading(false)
        }).catch(e => {
            setLoading(false)
        })
    }



    useEffect(() => {
        if (params.companyId !== "0") {
            reloadData()
        }
    }, [params.companyId])

    const addCompany = () => {
        API.addCompany(getValues()).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/company')
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }

    const saveCompany = () => {
        API.saveCompany(params.companyId ?? 0, getValues()).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/company')
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }

    const deleteCompany = () => {
        return API.deleteCompany(params.companyId ?? 0).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/company')
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }


    if (loading) {
        return (
            <div className="p-3">
                <div className="card">
                    <div className="card-header" style={{ height: '55px' }}>
                        <div className="mt-2">Spoločnosť: ...</div>
                    </div>
                    <div className="card-body">
                        Nahrávam
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header " style={{ height: '55px' }}>
                    <div className="row">
                        <div className="col-1">
                            <span className=""><Link to="/dashboard/company" className="btn btn-primary"><FontAwesomeIcon fixedWidth icon={["fas", "arrow-left"]} /> Späť</Link></span>
                        </div>
                        <div className="col-6">
                            <div className="mt-2">Spoločnosť: <strong>{
                                params.companyId === "0" ? '[ Vytvoriť novú ]' : getValues().name}</strong></div>
                        </div>
                        <div className="col-5 text-end">
                            {
                                params.companyId === "0" ?
                                    <button className="btn btn-primary" onClick={addCompany}><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} />  Pridať spoločnosť</button>
                                    :
                                    <>
                                        {
                                            !loading && !data.usage.length ?
                                                <button className="btn btn-danger me-3" onClick={() => showModal(
                                                    <ModalConfirmation
                                                        confirm={deleteCompany}
                                                        title={"Naozaj zmazať spoločnosť?"}
                                                        text="" />
                                                )}><FontAwesomeIcon fixedWidth icon={["fas", "trash"]} />  Zmazať spoločnosť</button>
                                                : null
                                        }
                                        <button className="btn btn-primary" onClick={saveCompany}><FontAwesomeIcon fixedWidth icon={["fas", "floppy-disk"]} />  Uložiť spoločnosť</button>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <ApiResult errorObject={apiResult} />
                    <div className="row">
                        <div className="col-4">
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Názov spoločnosti</label>
                                </div>
                                <div className="col-auto">
                                    <input type="text" {...register("name")} className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Popis</label>
                                </div>
                                <div className="col-8">
                                    <textarea rows={6} {...register("description")} className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-4  mt-1 text-end">
                                    <label className="form-label">Aktívny</label>
                                </div>
                                <div className="col-8  mt-1">
                                    <div className="form-check">

                                        <input className="form-check-input" {...register("status")} type="checkbox" />
                                        <label className="form-check-label">

                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="offset-4 col-4">
                            {
                                params.companyId !== "0" ?
                                    <>
                                        <h4>Odkazy na túto spoločnosť</h4>
                                        <DisplayUsage data={data.usage} />
                                    </>
                                    : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Company